import { BoundNumberField, Css, IconButton } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { Observer } from "mobx-react";
import { getStage } from "src/context";
import { BooleanParam, useQueryParams } from "use-query-params";
import { ProrationFormValues } from "../ProrateBidModal";

const threeDigitCurrencyFormat = { style: "currency" as const, currency: "USD", minimumFractionDigits: 3 };

export function ProrationUnitCostColumn({ prorationState }: { prorationState: ObjectState<ProrationFormValues> }) {
  const [{ enableProrationEstimation = false }] = useQueryParams({ enableProrationEstimation: BooleanParam });
  return (
    <Observer>
      {() => (
        <div css={Css.relative.$}>
          {prorationState.userEntered.value &&
            !prorationState.readOnly &&
            (getStage() !== "prod" || enableProrationEstimation) && (
              <div css={Css.absolute.left("-4px").top("2px").z1.$}>
                <IconButton
                  icon="pin"
                  onClick={() => prorationState.set({ userEntered: false })}
                  tooltip="Click the pin to enable estimation overwriting."
                />
              </div>
            )}
          <BoundNumberField
            numberFormatOptions={threeDigitCurrencyFormat}
            numFractionDigits={3}
            field={prorationState.unitCostInCents}
            onChange={(unitCostInCents) => prorationState.set({ unitCostInCents, userEntered: true })}
          />
        </div>
      )}
    </Observer>
  );
}

export function ProrationCostColumn({ prorationState }: { prorationState: ObjectState<ProrationFormValues> }) {
  const [{ enableProrationEstimation = false }] = useQueryParams({ enableProrationEstimation: BooleanParam });
  return (
    <Observer>
      {() => (
        <div css={Css.relative.$}>
          {prorationState.userEntered.value &&
            !prorationState.readOnly &&
            (getStage() !== "prod" || enableProrationEstimation) && (
              <div css={Css.absolute.left("-4px").top("2px").z1.$}>
                <IconButton
                  icon="pin"
                  onClick={() => prorationState.set({ userEntered: false })}
                  tooltip="Click the pin to enable estimation overwriting."
                />
              </div>
            )}
          <BoundNumberField
            field={prorationState.costInCents}
            onChange={(costInCents) => prorationState.set({ costInCents, userEntered: true })}
          />
        </div>
      )}
    </Observer>
  );
}
